import { unlockAccountRequestParamsSchema, unlockAccountResponseSchema } from './types';
export const unlockAccountDef = {
    name: 'unlockAccount',
    requestSchema: unlockAccountRequestParamsSchema,
    responseSchema: unlockAccountResponseSchema,
};
